import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Height from './Height';
import ClientProvider from './client';
export default createDemo(import.meta.url, Height, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/sizing/demos/height/Height.tsx",
    "fileName": "Height.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nexport default function Height() {\n  return (\n    <Box sx={{ height: 100, width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={(theme) => ({\n          height: '25%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 25%\n      </Box>\n      <Box\n        sx={(theme) => ({\n          height: '50%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 50%\n      </Box>\n      <Box\n        sx={(theme) => ({\n          height: '75%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 75%\n      </Box>\n      <Box\n        sx={(theme) => ({\n          height: '100%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 100%\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 104,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nexport default function Height() {\n  return (\n    <Box sx={{ height: 100, width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        sx={(theme) => ({\n          height: '25%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 25%\n      </Box>\n      <Box\n        sx={(theme) => ({\n          height: '50%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 50%\n      </Box>\n      <Box\n        sx={(theme) => ({\n          height: '75%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 75%\n      </Box>\n      <Box\n        sx={(theme) => ({\n          height: '100%',\n          width: 120,\n          display: 'inline-block',\n          p: 1,\n          mx: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          textAlign: 'center',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Height 100%\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 104,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
